var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-testid": _vm.testId } },
    [
      _c(
        "div",
        [
          _vm.csgHits.length > 0
            ? _c("AlgoliaCSGHits", {
                key: _vm.key,
                attrs: {
                  queryID: _vm.csgQueryID,
                  "in-header": _vm.inHeader,
                  mobile: _vm.mobile,
                  "is-staff-user": _vm.isStaffUser
                }
              })
            : _vm.coursesHits.length > 0
            ? _c("AlgoliaCourseHits", {
                key: _vm.key,
                attrs: {
                  queryID: _vm.courseQueryID,
                  "in-header": _vm.inHeader,
                  mobile: _vm.mobile,
                  "is-staff-user": _vm.isStaffUser
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      (_vm.csgHits.length | _vm.coursesHits.length) === 0
        ? _c("NoAlgoliaHits", { key: _vm.key, attrs: { mobile: _vm.mobile } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }